/**
 * 文件说明:
 *
 * hz page loading component
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import React from 'react'
import {Spin} from 'antd'
import styles from './index.less'

export default React.memo(({tip = '加载中...', size = 'large'}) => (
    <Spin size={size} wrapperClassName={styles.main} spinning tip={tip}>
        <span />
    </Spin>
))
